import { Button } from "@/components/ui/button";
import { EyebrowPill } from "@/components/shared/EyebrowPill";
import { SectionHeading } from "@/components/shared/SectionHeading";
import governanceShiftBooks from "@/assets/governance-shift-books.png.asset.json";

/**
 * Testimonials - Book promotion section for Angela Connell-Richards' two RTO books.
 */
export default function Testimonials() {
  return (
    <section className="py-20 md:py-28 bg-ch-lavender">
      <div className="max-w-6xl mx-auto py-16 px-6 md:py-20 md:px-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14 items-center">
          {/* Book image */}
          <img
            src={governanceShiftBooks.url}
            alt="The Governance Shift in Vocational Education and 8 Critical Drivers to RTO Success — two books by Angela Connell-Richards"
            className="block w-full h-auto object-contain mx-auto md:mx-0 animate-fade-up"
            style={{ maxWidth: 460 }}
            loading="lazy"
          />

          {/* Content */}
          <div className="animate-fade-up animate-delay-100">
            <EyebrowPill variant="onTint">From the Founder</EyebrowPill>

            <SectionHeading className="!text-left">
              Two Books. One Mission.
            </SectionHeading>

            <p className="font-carlito text-ch-acai mt-3" style={{ fontSize: 18 }}>
              Understand why some RTOs become systemised and others remain fragile — then build the platform that makes the difference.
            </p>

            <div className="font-carlito text-ch-acai/80 mt-4 space-y-3 leading-relaxed">
              <p>
                Angela Connell-Richards has spent 30 years helping Australian RTOs prepare for ASQA audits, navigate the Standards, and build governance systems that hold up under scrutiny. These two books distil that experience into a practical framework any RTO leader can apply.
              </p>
              <p>
                <em>The Governance Shift in Vocational Education</em> and <em>8 Critical Drivers to RTO Success</em> are available now through Vivacity — the advisory practice behind ComplyHub.
              </p>
            </div>

            <ul className="font-carlito text-ch-acai mt-4 space-y-2">
              <li className="flex items-start gap-2">
                <span className="text-ch-fuchsia mt-1">•</span>
                <span>The Governance Shift in Vocational Education</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-ch-fuchsia mt-1">•</span>
                <span>8 Critical Drivers to RTO Success</span>
              </li>
            </ul>

            <div className="mt-6">
              <a
                href="https://governance-shift.vivacity.com.au/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button size="lg" variant="chPrimary" className="h-12 px-8">
                  Get the Books →
                </Button>
              </a>
            </div>

            <p className="font-carlito text-sm text-ch-acai/60 mt-3">
              By Angela Connell-Richards — Governance Advisor, Speaker and Author in the Australian VET Sector
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
